export default {
	add_to_calendar: "Ajouter au calendrier",
	available_on_level: "Disponible au niveau",
	begin_date: "Date de début",
	check_in: "Enregistrement",
	checked_in: "Enregistré",
	code: "Code",
	doesnt_have_a_qrcode_reader_enter_the_check_in_code_bellow: "N'a pas de lecteur QR code? Entrez le code d'enregistrement ci-dessous.",
	dont_forget_to_come_and_visit_us_at: "N’oubliez pas de nous rendre visite à",
	end_date: "Date de fin",
	enter_the_check_in_code_bellow: "Entrez le code d'enregistrement ci-dessous.",
	enter_your_six_digits_code: "Entrez votre code à six chiffres",
	event_type: "Type d’évènements",
	get_back_later_to_check_new_event_available_to_you: "Revenez plus tard pour vérifier le nouvel évènement à votre disposition.",
	join_exclusive_events_for_intel_rewards_you_users_and_power_up_your_connection_with_the_intel_network: "Participez à des événements exclusifs pour les utilisateurs d'Intel Rewards You et renforcez votre connexion avec le réseau Intel!",
	no_events_are_available_at_the_moment: "Aucun évènement n’est disponible pour l’instant.",
	read_the_qrcode_at_the_event_to_check_in: "Lisez le QR code lors de l'événement pour vous enregistrer.",
	read_the_qrcode_available_at_the_event_to_check_in: "Lisez le QR Code disponible lors de l'événement pour marquer votre présence.",
	signed_up: "Inscrit(e)",
	signup: "Inscription",
	thank_you_for_participating_in_our_event_see_you_on_the_next_one: "Merci d'avoir participé à notre événement. Rendez-vous sur le prochain!",
	the_code_sent_is_invalid_confirm_the_code_with_the_event_organization: "Le code n'est pas valide. Veuillez confirmer le code avec l'organisation de l'événement."
}